import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import {
  IconButtonInternalConfig,
  IconMenuConfig,
} from './icon-menu-renderer.types';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'app-icon-menu-renderer',
  imports: [MatButtonModule, MatTooltipModule, MatIcon],
  templateUrl: './icon-menu-renderer.component.html',
  styleUrls: ['./icon-menu-renderer.component.scss'],
})
export class IconMenuRendererComponent<TData>
  implements ICellRendererAngularComp
{
  private params: ICellRendererParams<TData, IconMenuConfig<TData>> | undefined;

  buttons: IconButtonInternalConfig[] = [];

  agInit(params: ICellRendererParams<TData, IconMenuConfig<TData>>): void {
    this.params = params;
    this.updateDisplayedButtons();
  }
  refresh(params: ICellRendererParams<TData, IconMenuConfig<TData>>): boolean {
    this.params = params;
    this.updateDisplayedButtons();
    return true;
  }

  private updateDisplayedButtons() {
    const data = this.params?.data;
    if (this.params === undefined || data === undefined || data === null) {
      return;
    }
    const buttons: IconButtonInternalConfig[] = [];
    this.params.value?.buttons.forEach(button => {
      const show = data && (button.showIf === undefined || button.showIf(data));
      if (show) {
        const { icon, tooltip } = button;
        const callback = () => button.callback(data);
        buttons.push({ icon, tooltip, callback });
      }
    });
    this.buttons = buttons;
  }
}
